import api from "../services/api";

const path = "segmento";

export const getSegments = async () => {
  return await api.get(`${path}/todos`);
};

export const findSegment = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editSegment = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createSegment = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteSegment = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
